export enum ConfigurationsEnum {
    ControlProductStock = 1,
    ProductCodeWillBe = 2,
    EmitNfce = 3,
    AcceptDebitCard = 4,
    AcceptCreditCard = 5,
    AcceptPix = 6,
    PriceFormation = 7,
    CostPriceCalculation = 8,
    AcceptMoney = 9
}
